import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { AuthContext } from "./context";
import { doctorServices } from "./services";
export default function AuthHandler() {
  const history = useHistory();
  const { signIn } = useContext(AuthContext);

  useEffect(() => {
    async function processAuth() {
      // Función auxiliar para obtener la cookie
      const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
      };

      // 1. Buscamos el token donde sea que venga (Cookie, URL, LocalStorage)
      let token = getCookie("unio_token");

      if (!token) {
        const urlParams = new URLSearchParams(window.location.search);
        token = urlParams.get("token");
        if (!token && window.location.hash.includes("token=")) {
          token = window.location.hash.split("token=")[1].split("&")[0];
        }
      }

      if (!token) {
        token = localStorage.getItem("token");
      }

      if (token) {
        try {
          // 2. Validamos el token con el backend para obtener los datos de usuario
          const { status, response } = await doctorServices.verifyTokenValidity({
            token,
          });

          const accessToken = response.token || response.user?.token || response.accessToken || token;

          // 3. Registramos la sesión en el contexto global
          signIn({
            token: accessToken,
            user: response,
            doctor: response.doctor,
          });

          // Limpiamos la cookie si existe
          document.cookie = "unio_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.unio.cl; path=/;";

          // 4. Vamos al Home
          history.replace("/");
        } catch (error) {
          console.error("Error validando token en AuthHandler", error);
          history.replace("/iniciar-sesion");
        }
      } else {
        // No hay token, mandamos a login
        history.replace("/iniciar-sesion");
      }
    }

    processAuth();
  }, [history, signIn]);

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        zIndex: 9999,
        height: "100vh",
        width: "100vw",
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <img
        src="../../spinner-unio.gif"
        alt="spinner"
        width="150px"
        height="150px"
      />
      Redirigiendo
    </div>
  );
}
